import { useUserData } from '../../../../hooks'
import { useCalendarRequestsDayLoad } from '../../../CalendarDayLoad'
import { getMockCalendarRequestsDayLoad } from '../../Calendar.mock'
import { getCalendarOwnDayLoad } from '../../Calendar.utils'

export function useCalendarDayLoad({ date, requestIds }) {
  const userData = useUserData()

  // TODO: drop the calendar mock reader once the backend serves the day load
  // (TM-01-12).
  async function readDayLoad(params) {
    return getMockCalendarRequestsDayLoad({ ...params, user: userData })
  }

  const { data, isFailed, isLoading } = useCalendarRequestsDayLoad({
    date,
    readDayLoad,
    requestIds,
  })

  return {
    dayLoad: data
      ? getCalendarOwnDayLoad({ data, date, user: userData })
      : null,
    isFailed,
    isLoading,
  }
}
